import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { useContext } from '@nuxtjs/composition-api';
import { CdnImg } from '@webplatform/cdn-image';
import { handleImageSrc, handleImageAlt } from '~/helpers';

interface Props {
  items?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryFeaturesBlocks',
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {



const { $gsap, $ScrollTrigger } = useContext();
const section = ref();
const block = ref();

onMounted(() => {
  if (!block.value) return;

  const contentChunks: HTMLElement[] = [...block.value.children];

  const tl = $gsap.timeline({
    scrollTrigger: {
      trigger: block.value,
      start: 'top top',
      end: '+=2500',
      scrub: 1,
      toggleActions: 'restart none none reverse',
    },
  });

  contentChunks.forEach((chunk, i) => {
    tl.fromTo(chunk, { zIndex: i === 0 ? 1 : 'auto' }, { zIndex: 2 });

    if (i !== 0) {
      tl.fromTo(
        chunk.querySelector('.text-block'),
        { yPercent: 10, autoAlpha: 0 },
        { yPercent: 0, autoAlpha: 1 },
      );

      tl.fromTo(
        chunk.querySelector('.image-block'),
        { autoAlpha: 0 },
        { autoAlpha: 1 },
        '<',
      );
    }

    if (i < contentChunks.length - 1) {
      tl.to(
        chunk.querySelector('.text-block'),
        { yPercent: -10, autoAlpha: 0 },
        '+=3',
      );
    }
  });

  $ScrollTrigger.create({
    trigger: section.value,
    start: 'center center',
    end: '+=3500',
    pin: true,
  });

  setTimeout(() => {
    $ScrollTrigger.refresh();
  }, 200);
});

return { __sfc: true,$gsap, $ScrollTrigger, section, block, CdnImg, handleImageSrc, handleImageAlt }
}

})